const UI_TRANSLATIONS = {
  en: {
    loading: 'Loading',
    selectLanguageTitle: 'Select Language',
    searchLanguagesPlaceholder: 'Search languages...',
    clearSearch: 'Clear search',
    close: 'Close',
    languageCountSingular: '{count} language available',
    languageCountPlural: '{count} languages available',
    noLanguagesFound: 'No languages found matching "{query}"',
    downloadApp: 'Download the app',
    allRightsReserved: 'All rights reserved.',
    qrErrorAlt: 'QR error',
    foodAllergyCardAlt: 'Food Allergy Card',
    playStoreAlt: 'Play Store',
    appStoreAlt: 'App Store',
    alertIconAlt: 'Alert icon',
    languageIconAlt: 'Language icon',
    playSoundAlt: 'Play sound',
    speakerAlt: 'Speaker',
    imageToggleAlt: 'Toggle images',
    flagAlt: 'Flag',
    switchTo: 'Switch to',
    icons: 'icons',
    images: 'images',
    tapTo: 'Tap to',
    changeLanguage: 'change language',
    tapToHear: 'Tap to hear',
    theText: 'the text',
    accessValidUntil: 'Access valid until {time}',
    reloadHint: 'If this page stops working, reload to continue.',
    qrDisabledTitle: 'QR Code Disabled',
    qrExpiredTitle: 'QR Code Expired',
    accessExpiredTitle: 'Access Expired',
    qrNotAvailableTitle: 'QR Code Not Available',
    cardNotLinkedTitle: 'Card Not Linked',
    dataLoadingErrorTitle: 'Data Loading Error',
    serviceUnavailableTitle: 'Service Unavailable',
    qrDisabledMessage: 'This QR code has been disabled by the owner. Please contact them for assistance or request a new QR code.',
    qrExpiredMessage: 'This QR code has expired and is no longer valid. Please contact the owner for a new QR code.',
    accessExpiredMessage: 'Your access window has ended. Please reload the page or rescan the QR code to access it again.',
    qrNotAvailableMessage: 'This QR code does not exist in our system. Please verify the QR code and try again, or contact the owner.',
    noCardMessage: 'This QR code is not associated with any allergy card. Please ask the owner to link a card to this QR code in the app.',
    dataLoadingErrorMessage: 'We could not load all the allergy information. This might be a temporary issue. Please try refreshing the page.',
    serviceUnavailableMessage: 'The service is not working at this moment. Please try again later.',
    qrInvalidMessage: 'The QR code you scanned is invalid or does not exist. Please try scanning again or contact support.'
  },
  de: {
    loading: 'Wird geladen',
    selectLanguageTitle: 'Sprache auswahlen',
    searchLanguagesPlaceholder: 'Sprachen suchen...',
    clearSearch: 'Suche leeren',
    close: 'Schliessen',
    languageCountSingular: '{count} Sprache verfugbar',
    languageCountPlural: '{count} Sprachen verfugbar',
    noLanguagesFound: 'Keine Sprachen passend zu "{query}" gefunden',
    downloadApp: 'App herunterladen',
    allRightsReserved: 'Alle Rechte vorbehalten.',
    qrErrorAlt: 'QR-Fehler',
    foodAllergyCardAlt: 'Food Allergy Card',
    playStoreAlt: 'Play Store',
    appStoreAlt: 'App Store',
    alertIconAlt: 'Warnsymbol',
    languageIconAlt: 'Sprachsymbol',
    playSoundAlt: 'Ton abspielen',
    speakerAlt: 'Lautsprecher',
    imageToggleAlt: 'Bilder umschalten',
    flagAlt: 'Flagge',
    switchTo: 'Wechseln zu',
    icons: 'Symbolen',
    images: 'Bildern',
    tapTo: 'Tippen zum',
    changeLanguage: 'Sprachwechsel',
    tapToHear: 'Tippen, um',
    theText: 'den Text zu horen',
    accessValidUntil: 'Zugang gultig bis {time}',
    reloadHint: 'Wenn diese Seite nicht mehr funktioniert, laden Sie sie neu.',
    qrDisabledTitle: 'QR-Code deaktiviert',
    qrExpiredTitle: 'QR-Code abgelaufen',
    accessExpiredTitle: 'Zugang abgelaufen',
    qrNotAvailableTitle: 'QR-Code nicht verfugbar',
    cardNotLinkedTitle: 'Keine Karte verknupft',
    dataLoadingErrorTitle: 'Fehler beim Laden der Daten',
    serviceUnavailableTitle: 'Dienst nicht verfugbar',
    qrDisabledMessage: 'Dieser QR-Code wurde vom Eigentumer deaktiviert. Bitte kontaktieren Sie ihn oder fordern Sie einen neuen QR-Code an.',
    qrExpiredMessage: 'Dieser QR-Code ist abgelaufen und nicht mehr gultig. Bitte kontaktieren Sie den Eigentumer fur einen neuen QR-Code.',
    accessExpiredMessage: 'Ihr Zugriffsfenster ist abgelaufen. Bitte laden Sie die Seite neu oder scannen Sie den QR-Code erneut.',
    qrNotAvailableMessage: 'Dieser QR-Code existiert nicht in unserem System. Bitte uberprufen Sie den QR-Code oder kontaktieren Sie den Eigentumer.',
    noCardMessage: 'Dieser QR-Code ist keiner Allergiekarte zugeordnet. Bitten Sie den Eigentumer, in der App eine Karte mit diesem QR-Code zu verknupfen.',
    dataLoadingErrorMessage: 'Wir konnten nicht alle Allergieinformationen laden. Das konnte ein vorubergehendes Problem sein. Bitte aktualisieren Sie die Seite.',
    serviceUnavailableMessage: 'Der Dienst ist momentan nicht verfugbar. Bitte versuchen Sie es spater erneut.',
    qrInvalidMessage: 'Der gescannte QR-Code ist ungunstig oder existiert nicht. Bitte scannen Sie erneut oder kontaktieren Sie den Support.'
  },
  fr: {
    loading: 'Chargement',
    selectLanguageTitle: 'Choisir la langue',
    searchLanguagesPlaceholder: 'Rechercher des langues...',
    clearSearch: 'Effacer la recherche',
    close: 'Fermer',
    languageCountSingular: '{count} langue disponible',
    languageCountPlural: '{count} langues disponibles',
    noLanguagesFound: 'Aucune langue ne correspond a "{query}"',
    downloadApp: 'Telecharger l\'application',
    allRightsReserved: 'Tous droits reserves.',
    qrErrorAlt: 'Erreur QR',
    foodAllergyCardAlt: 'Food Allergy Card',
    playStoreAlt: 'Play Store',
    appStoreAlt: 'App Store',
    alertIconAlt: 'Icone d\'alerte',
    languageIconAlt: 'Icone de langue',
    playSoundAlt: 'Lire le son',
    speakerAlt: 'Haut-parleur',
    imageToggleAlt: 'Changer les images',
    flagAlt: 'Drapeau',
    switchTo: 'Passer aux',
    icons: 'icones',
    images: 'images',
    tapTo: 'Touchez pour',
    changeLanguage: 'changer la langue',
    tapToHear: 'Touchez pour entendre',
    theText: 'le texte',
    accessValidUntil: 'Acces valide jusqu\'a {time}',
    reloadHint: 'Si cette page cesse de fonctionner, rechargez-la.',
    qrDisabledTitle: 'Code QR desactive',
    qrExpiredTitle: 'Code QR expire',
    accessExpiredTitle: 'Acces expire',
    qrNotAvailableTitle: 'Code QR indisponible',
    cardNotLinkedTitle: 'Carte non liee',
    dataLoadingErrorTitle: 'Erreur de chargement des donnees',
    serviceUnavailableTitle: 'Service indisponible',
    qrDisabledMessage: 'Ce code QR a ete desactive par son proprietaire. Veuillez le contacter ou demander un nouveau code QR.',
    qrExpiredMessage: 'Ce code QR a expire et n\'est plus valide. Veuillez contacter le proprietaire pour en obtenir un nouveau.',
    accessExpiredMessage: 'Votre fenetre d\'acces est terminee. Rechargez la page ou rescanez le code QR pour continuer.',
    qrNotAvailableMessage: 'Ce code QR n\'existe pas dans notre systeme. Verifiez le code QR ou contactez le proprietaire.',
    noCardMessage: 'Ce code QR n\'est associe a aucune carte d\'allergie. Demandez au proprietaire de relier une carte a ce code QR dans l\'application.',
    dataLoadingErrorMessage: 'Nous n\'avons pas pu charger toutes les informations sur les allergies. Il s\'agit peut-etre d\'un probleme temporaire. Veuillez actualiser la page.',
    serviceUnavailableMessage: 'Le service ne fonctionne pas pour le moment. Veuillez reessayer plus tard.',
    qrInvalidMessage: 'Le code QR scanne est invalide ou n\'existe pas. Veuillez rescanner ou contacter l\'assistance.'
  },
  es: {
    loading: 'Cargando',
    selectLanguageTitle: 'Seleccionar idioma',
    searchLanguagesPlaceholder: 'Buscar idiomas...',
    clearSearch: 'Borrar busqueda',
    close: 'Cerrar',
    languageCountSingular: '{count} idioma disponible',
    languageCountPlural: '{count} idiomas disponibles',
    noLanguagesFound: 'No se encontraron idiomas que coincidan con "{query}"',
    downloadApp: 'Descargar la aplicacion',
    allRightsReserved: 'Todos los derechos reservados.',
    qrErrorAlt: 'Error de QR',
    foodAllergyCardAlt: 'Food Allergy Card',
    playStoreAlt: 'Play Store',
    appStoreAlt: 'App Store',
    alertIconAlt: 'Icono de alerta',
    languageIconAlt: 'Icono de idioma',
    playSoundAlt: 'Reproducir sonido',
    speakerAlt: 'Altavoz',
    imageToggleAlt: 'Cambiar imagenes',
    flagAlt: 'Bandera',
    switchTo: 'Cambiar a',
    icons: 'iconos',
    images: 'imagenes',
    tapTo: 'Toca para',
    changeLanguage: 'cambiar idioma',
    tapToHear: 'Toca para escuchar',
    theText: 'el texto',
    accessValidUntil: 'Acceso valido hasta las {time}',
    reloadHint: 'Si esta pagina deja de funcionar, recargala para continuar.',
    qrDisabledTitle: 'Codigo QR desactivado',
    qrExpiredTitle: 'Codigo QR caducado',
    accessExpiredTitle: 'Acceso caducado',
    qrNotAvailableTitle: 'Codigo QR no disponible',
    cardNotLinkedTitle: 'Tarjeta no vinculada',
    dataLoadingErrorTitle: 'Error al cargar los datos',
    serviceUnavailableTitle: 'Servicio no disponible',
    qrDisabledMessage: 'Este codigo QR ha sido desactivado por el propietario. Contactalo o solicita un nuevo codigo QR.',
    qrExpiredMessage: 'Este codigo QR ha caducado y ya no es valido. Contacta al propietario para obtener un nuevo codigo QR.',
    accessExpiredMessage: 'Tu ventana de acceso ha finalizado. Recarga la pagina o vuelve a escanear el codigo QR para continuar.',
    qrNotAvailableMessage: 'Este codigo QR no existe en nuestro sistema. Verifica el codigo QR o contacta al propietario.',
    noCardMessage: 'Este codigo QR no esta asociado a ninguna tarjeta de alergias. Pide al propietario que vincule una tarjeta a este codigo QR en la aplicacion.',
    dataLoadingErrorMessage: 'No pudimos cargar toda la informacion sobre alergias. Puede ser un problema temporal. Intenta actualizar la pagina.',
    serviceUnavailableMessage: 'El servicio no funciona en este momento. Intentalo de nuevo mas tarde.',
    qrInvalidMessage: 'El codigo QR escaneado no es valido o no existe. Vuelve a escanearlo o contacta con soporte.'
  }
};

const SUPPORTED_UI_LOCALES = Object.keys(UI_TRANSLATIONS);

export const getUiLocale = (languageCode) => {
  const locale = String(languageCode || 'en').toLowerCase().substring(0, 2);
  return SUPPORTED_UI_LOCALES.includes(locale) ? locale : 'en';
};

export const translateUiText = (languageCode, key, values = {}) => {
  const locale = getUiLocale(languageCode);
  const template = UI_TRANSLATIONS[locale]?.[key] || UI_TRANSLATIONS.en[key] || key;

  return template.replace(/\{(\w+)\}/g, (_, token) => {
    if (values[token] === undefined || values[token] === null) {
      return '';
    }

    return String(values[token]);
  });
};
